import { DestroyRef, inject, Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CurrentTimeService {
  private destroyRef = inject(DestroyRef);

  currentTime = signal(new Date());

  constructor() {
    const interval = setInterval(() => this.currentTime.set(new Date()), 10_000);
    this.destroyRef.onDestroy(() => clearInterval(interval));
  }
}
